import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=2d8f8719&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"
import style0 from "./Properties.vue?vue&type=style&index=0&id=2d8f8719&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f8719",
  null
  
)

export default component.exports